import { COUNTRY, LANGUAGE } from "@type/index";

export class CurrencyFormatter {
  country: COUNTRY;
  language: LANGUAGE;
  constructor(country: COUNTRY, language: LANGUAGE) {
    this.country = country;
    this.language = language;
  }

  // This function inserts a given separator to value
  static addSeparator(value: string, separator: string, by: number): string {
    return value.replace(/./g, (char, index, all) =>
      index && (all.length - index) % by === 0 ? separator + char : char
    );
  }

  formatInteger(integer: string) {
    return CurrencyFormatter.addSeparator(integer, this.seperatorSymbol(), 3);
  }

  decimalSymbol() {
    switch (`${this.language}-${this.country}`) {
      case `${LANGUAGE.ZHHK}-${COUNTRY.HK}`:
      case `${LANGUAGE.ENGB}-${COUNTRY.HK}`:
        return ".";
      default:
        return "";
    }
  }
  seperatorSymbol() {
    switch (`${this.language}-${this.country}`) {
      case `${LANGUAGE.ZHHK}-${COUNTRY.HK}`:
        return ",";
      default:
        return ",";
    }
  }
  discardDecimalIfZero() {
    switch (`${this.language}-${this.country}`) {
      default:
        return false;
    }
  }
  formatDecimal(symbol: string, decimal: string) {
    if (Number.parseInt(decimal, 10) === 0 && symbol) {
      return this.discardDecimalIfZero() ? "" : `${symbol}${decimal}`;
    }
    return symbol ? `${symbol}${decimal}` : "";
  }
  // Return proper formatted currency value
  format(value: number | string) {
    let valueToString = "";
    let negativeSymbol = "";

    if (typeof value === "number") {
      if (value < 0) {
        valueToString = String(-value);
        negativeSymbol = "-";
      } else {
        valueToString = String(value);
      }
    } else if (typeof value === "string") {
      if (value[0] === "-") {
        valueToString = value.slice(1);
        negativeSymbol = "-";
      } else {
        valueToString = value;
      }
    }

    // parseFloat expects string as its argument
    const parsedPrice = Number.parseFloat(valueToString).toFixed(2);
    const [integer, decimal] = parsedPrice.split(".");
    const symbol = this.decimalSymbol();
    const formattedInteger = this.formatInteger(integer);
    const formattedDecimal = this.formatDecimal(symbol, decimal);
    return `${negativeSymbol}${formattedInteger}${formattedDecimal}`;
  }
}
